<template>
  <nav
    class="tw-flex tw-items-center tw-gap-2 tw-text-sm"
    aria-label="Kruimelpad"
  >
    <template v-for="(item, index) in items" :key="index">
      <router-link
        v-if="item.to"
        :to="item.to"
        class="tw-font-medium tw-text-gray-500 hover:tw-text-gray-900"
      >
        {{ item.label }}
      </router-link>
      <span v-else class="tw-font-medium tw-text-gray-900">
        {{ item.label }}
      </span>

      <q-icon
        v-if="index < items.length - 1"
        :name="toClassicIcon('fa-chevron-right')"
        size="12px"
        class="tw-text-gray-500"
      />
    </template>
  </nav>
</template>

<script setup lang="ts">
import { toClassicIcon } from "common/defaultIcons";
import type { RouteLocationRaw } from "vue-router";

export interface BreadcrumbItem {
  label: string;
  to?: RouteLocationRaw;
}

defineProps<{
  items: BreadcrumbItem[];
}>();
</script>
